import { render, staticRenderFns } from "./InChange.vue?vue&type=template&id=72c955e2&scoped=true&slot-scope=scope&"
import script from "./InChange.vue?vue&type=script&lang=js&"
export * from "./InChange.vue?vue&type=script&lang=js&"
import style0 from "./InChange.vue?vue&type=style&index=0&id=72c955e2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c955e2",
  null
  
)

export default component.exports